import axios from 'axios';
import { siteURL } from '../config/constants';

export const axiosInstance = axios.create({
    baseURL: siteURL,
    // Required so Set-Cookie from login/register is stored and sent on refresh-token.
    withCredentials: true,
});